import { BaseService } from '@/infrastructure/api/base.service'
import type { DatapointsResponse } from '@/domain/entities/Datapoints'

export class DatapointService extends BaseService {
  constructor() {
    super('')
  }

  async getDatapoints(): Promise<DatapointsResponse> {
    return this.post<DatapointsResponse>('/V2/Datapoint/GetDatapoints', {})
  }
}
